import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { BellOff, Bell } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { Spinner } from "@/components/kit";

export default function StopReminders() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const [state, setState] = useState("working");
  const [err, setErr] = useState("");

  const set = async (enabled) => {
    setState("working");
    try {
      await api.post(`/supporters/view/${token}/streak-reminders`, { enabled });
      setState(enabled ? "on" : "off");
    } catch (e) {
      setErr(errMsg(e, "Invalid link"));
      setState("error");
    }
  };
  useEffect(() => { set(false); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (state === "working") return <Spinner className="min-h-screen items-center" />;
  return (
    <div className="min-h-screen flex items-center justify-center mm-gradient-soft px-5">
      <div className="mm-card p-10 max-w-md w-full text-center mm-fade-up" data-testid="stop-reminders-card">
        {state === "error" ? (
          <p className="text-mm-error" data-testid="stop-reminders-error">{err}</p>
        ) : (
          <>
            {state === "off" ? <BellOff className="mx-auto text-mm-muted" size={44} /> : <Bell className="mx-auto text-mm-primary" size={44} />}
            <h1 className="text-2xl font-bold mt-4" data-testid="stop-reminders-title">{state === "off" ? "Streak reminders stopped" : "Streak reminders back on"}</h1>
            <p className="text-mm-muted mt-2">{state === "off" ? "You won't get Friday streak reminders anymore. You can still send notes any time." : "We'll nudge you on Fridays if your streak is about to end."}</p>
            <div className="flex flex-col gap-2 mt-6">
              <Link to={`/supporter-view?token=${token}`} className="mm-btn" data-testid="stop-reminders-view">Go to supporter page</Link>
              <button className="mm-btn-ghost" onClick={() => set(state !== "on")} data-testid="stop-reminders-toggle">{state === "off" ? "Turn reminders back on" : "Stop reminders"}</button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
